var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgReadwiseGlyph(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.5712 27.6149C30.4119 28.9957 31.0976 29.4547 32.5 29.6192V31H25.581L19.0998 20.3205H17.4805V27.3203C17.4805 29.1946 17.9492 29.4547 19.9443 29.6192V31H9.5V29.6192C11.4951 29.4547 11.9639 29.1908 11.9639 27.3203V11.6797C11.9639 9.7748 11.5571 9.54529 9.5 9.38081V8H20.2504C26.7316 8 30.1175 9.34638 30.1175 14.078C30.1175 17.6583 28.3548 19.368 24.8023 19.9571L29.5712 27.6149ZM24.7145 16.1666C24.7145 16.1666 23.8661 11.4617 24.4163 10.4634L17.3965 18.1174C19.1128 16.7097 24.3078 16.6867 24.3078 16.6867C24.5557 16.6332 24.7261 16.4152 24.7145 16.1666Z",
    fill: "white"
  })));
}

export default SvgReadwiseGlyph;